import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { WidgetApiService } from "@shared/services/integrations/widget-api.service";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ToasterService } from "@shared/services/toaster.service";
import { TranslateService } from "@ngx-translate/core";
import { LogService } from "@shared/services/log.service";

import { SpinnerComponent } from "../../elements/spinner/spinner.component";

@Component({
    selector: "my-terms-widget-wrapper",
    templateUrl: "terms.component.html",
    styleUrls: ["terms.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SpinnerComponent]
})
export class TermsWidgetWrapperComponent implements OnInit {
    public isLoading = true;
    public html: SafeHtml;

    constructor(
        private readonly activatedRoute: ActivatedRoute,
        private readonly sanitizer: DomSanitizer,
        private readonly toaster: ToasterService,
        private readonly widgetApi: WidgetApiService,
        public translate: TranslateService,
        private readonly logService: LogService
    ) {
        this.translate = translate;
    }

    public ngOnInit(): void {
        const params: any = this.activatedRoute.snapshot.params;

        this.widgetApi
            .getTerms(params.shortcode, params.lang, params.version)
            .then((terms) => {
                this.html = this.sanitizer.bypassSecurityTrustHtml(terms.text);
                this.isLoading = false;
            })
            .catch((err) => {
                this.logService.error(err);
                this.translate.get("Error loading policy").subscribe((res: string) => {
                    this.toaster.pop("error", res);
                });
            });
    }
}
